// 19.1.2.15 Object.preventExtensions(O)
var isObject = require('./$.is-object');

require('./$.object-sap')('preventExtensions', function($preventExtensions){
  return function preventExtensions(it){
    return $preventExtensions && isObject(it) ? $preventExtensions(it) : it;
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/es6.object.prevent-extensions.js
// module id = 138
// module chunks = 0